import axiosInstance from './axios.config'
import { memberareaService } from './memberarea.service'

const API_URL = import.meta.env.VITE_API_URL

// Ajout de l'intercepteur pour le token
axiosInstance.interceptors.request.use(config => {
  const user = JSON.parse(localStorage.getItem('user'))
  if (user?.token) {
    config.headers.Authorization = `Bearer ${user.token}`
  }
  return config
})

export const authService = {
  async login(email, password) {
    try {
      // Récupérer et parser le panier temporaire avant la connexion
      let tempCart = []
      try {
        const tempCartString = localStorage.getItem('tempCart')
        if (tempCartString) {
          tempCart = JSON.parse(tempCartString)
          if (!Array.isArray(tempCart)) {
            tempCart = []
          }
        }
      } catch (e) {
        console.error('Erreur lors de la lecture du panier temporaire:', e)
      }

      // Effectuer la connexion
      const response = await axiosInstance.post('/auth/login', {
        email,
        password
      })

      if (response.data.token) {
        localStorage.setItem('user', JSON.stringify(response.data))

        // Fusionner le panier temporaire si nécessaire
        if (tempCart.length > 0) {
          console.log('Fusion du panier temporaire:', tempCart)
          
          for (const item of tempCart) {
            if (item && item.projectId) {
              try {
                await memberareaService.addToCart(
                  item.projectId,
                  item.isGift || false,
                  item.beneficiaryInfo || null
                )
              } catch (error) {
                console.error('Erreur lors de l\'ajout d\'un item au panier:', error)
              }
            }
          }

          // Nettoyer le panier temporaire
          localStorage.removeItem('tempCart')
        }
      }

      return response.data
    } catch (error) {
      console.error('Erreur lors de la connexion:', error)
      throw error
    }
  },

  async me() {
    const response = await axiosInstance.get('/auth/me')
    return response.data
  },

  async forgotPassword(email) {
    return axiosInstance.post('/auth/forgot-password', { email })
  },

  async resetPassword(token, password) {
    return axiosInstance.post(`/auth/reset-password/${token}`, { password })
  },

  logout() {
    localStorage.removeItem('user')
  },

  async register(userData) {
    const response = await axiosInstance.post('/auth/register', userData)
    return response.data
  },

  async getPlanPricing(planId) {
    try {
      const response = await axiosInstance.get(`/public/register-with-plan/pricing/${planId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async registerWithPlan(userData, planId, isGift = false, giftData = null) {
    try {
      const response = await axiosInstance.post('/api/public/register-with-plan', {
        email: userData.email,
        password: userData.password,
        firstname: userData.firstname,
        lastname: userData.lastname,
        planId,
        isGift,
        giftData
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async verifyRegisterWithPlan(sessionId) {
    try {
      const response = await axiosInstance.get(`/api/public/register-with-plan/verify/${sessionId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
} 